var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 23,
  viewBox: "0 0 19 23",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#595959",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M468.438 218c1.904 0 3.459 1.505 3.557 3.399l.005.19v15.822c0 1.918-1.494 3.485-3.373 3.584l-.19.005h-7.52c-.328 0-.594-.268-.594-.598 0-.298.215-.544.497-.59l.096-.008h7.522c1.257 0 2.286-.984 2.37-2.23l.005-.163v-15.822c0-1.266-.977-2.303-2.212-2.387l-.163-.006h-7.522c-.327 0-.593-.267-.593-.598 0-.297.215-.544.497-.59l.096-.008h7.522zm-9.637 6.253c.206.208.229.53.069.763l-.07.083-3.83 3.859h9.904c.328 0 .594.268.594.598 0 .298-.215.544-.497.59l-.097.008h-9.791l3.718 3.747c.206.207.229.53.069.763l-.07.083c-.205.207-.525.23-.757.069l-.082-.07-4.787-4.823c-.206-.208-.23-.53-.069-.763l.069-.083 4.787-4.824c.232-.233.608-.233.84 0z",
  transform: "translate(-453 -218)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export default ForwardRef;